module.exports = __webpack_public_path__ + "media/bgm_sample.dad594bc.mp3";